import { DEFAULT_VALUE, emptyString } from "../../../../../constants";
import { compactNumberFormat } from "../../../../../shared";
import {
  BRAND_REPORT_CHANNEL,
  BRAND_REPORT_INSIGHT_COPY,
  BRAND_REPORT_INSIGHT_TITLES,
} from "../../../constants/brandReport.constants";

// Checks if brand report has data for POS or Online channels
export const getBrandReportDataFlags = (brandReport) => {
  const hasPosData =
    brandReport?.pos &&
    brandReport?.pos?.totalSurveySentCount?.value > DEFAULT_VALUE;
  const hasOnlineData =
    brandReport?.online &&
    brandReport?.online?.totalSurveySentCount?.value > DEFAULT_VALUE;
  const hasNoData = !hasPosData && !hasOnlineData;
  const isSingleSection =
    (hasPosData && !hasOnlineData) || (!hasPosData && hasOnlineData);

  return {
    hasPosData,
    hasOnlineData,
    hasNoData,
    isSingleSection,
  };
};

/**
 * Query string for brand Async search.
 */
export const buildBrandSearchQuery = (inputValue) => ({
  search: inputValue || emptyString,
});

/**
 * Description under the Total Surveys insight card.
 */
export const getTotalSurveysDescription = ({ hasPosData, hasOnlineData }) => {
  if (hasPosData && hasOnlineData) {
    return BRAND_REPORT_INSIGHT_COPY.TOTAL_SURVEYS_COMBINED;
  }
  if (hasPosData) {
    return BRAND_REPORT_INSIGHT_COPY.TOTAL_SURVEYS_VIA_POS;
  }
  if (hasOnlineData) {
    return BRAND_REPORT_INSIGHT_COPY.TOTAL_SURVEYS_VIA_ONLINE;
  }
  return BRAND_REPORT_INSIGHT_COPY.TOTAL_SURVEYS_COMBINED;
};

/**
 * Description under the Overall Completion insight card.
 */
export const getCompletionDescription = ({ hasPosData, hasOnlineData }) => {
  if (hasPosData && hasOnlineData) {
    return BRAND_REPORT_INSIGHT_COPY.AVERAGE_COMPLETION_RATE;
  }
  return BRAND_REPORT_INSIGHT_COPY.COMPLETION_RATE;
};

/**
 * Best channel label from POS vs Online completion percentages.
 */
export const getBestChannel = (posCompletion, onlineCompletion) => {
  if (posCompletion === onlineCompletion) {
    return BRAND_REPORT_CHANNEL.BALANCED;
  }
  if (posCompletion > onlineCompletion) {
    return BRAND_REPORT_CHANNEL.POS;
  }
  return BRAND_REPORT_CHANNEL.ONLINE;
};

/**
 * Title / value / description for the channel insight card.
 */
export const getChannelCardInfo = ({
  isSingleChannel,
  hasPosData,
  bestChannel,
  percentageDifference,
}) => {
  if (isSingleChannel) {
    const activeChannel = hasPosData
      ? BRAND_REPORT_CHANNEL.POS
      : BRAND_REPORT_CHANNEL.ONLINE;
    return {
      title: BRAND_REPORT_INSIGHT_TITLES.ACTIVE_CHANNEL,
      value: activeChannel,
      description: BRAND_REPORT_INSIGHT_COPY.PRIMARY_FEEDBACK_SOURCE,
    };
  }

  let description = BRAND_REPORT_INSIGHT_COPY.COMPLETION_RATES_SAME;
  if (percentageDifference) {
    description = `${compactNumberFormat(percentageDifference)}% ${
      BRAND_REPORT_INSIGHT_COPY.HIGHER_COMPLETION_RATE
    }`;
  }

  return {
    title: BRAND_REPORT_INSIGHT_TITLES.BEST_CHANNEL,
    value: bestChannel,
    description,
  };
};
